<template>
    <div
      id="kyuyo_manage"
    >
      <div class="h-100">
        <div class="flex-grow-1">
          <!-- ヘッダー -->
          <header class="sticky-top">
            <b-row
              id="header-base"
              no-gutters
              class="header_content box_float_style px-3 py-1 sticky-top"
            >
              <b-col cols="8" class="text-left system_title">
                <b-button size="lg"  variant="outline-light" to="/manager/Home">{{ companyName }} 勤怠管理システム</b-button>
              </b-col>
              <b-col class="d-flex align-items-end flex-column" cols="4">
                <div class="text-left mr-2 mt-auto" style="color: white; text-align: left;">
                  <b-icon icon="person-fill" class="mr-1"></b-icon>{{ loginUserName }}</div>
                  <div class="mr-2 mt-auto" style=" color: white;">{{ loginUserId }}</div>
              </b-col>
            </b-row>
          </header>
          <!-- サイドバー -->
          <nav class="d-none d-md-block sidebar">
            <div class="sidebar-sticky">
              <div class="mt-4">
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/WorkRegist"
                  :class="getClassBtnSideMenu('/manager/WorkRegist')"
                >
                  <b-icon icon="file-earmark-spreadsheet" class="mr-2"></b-icon>勤怠報告
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/WorkCalendar"
                  :class="getClassBtnSideMenu('/manager/WorkCalendar')"
                >
                  <b-icon icon="calendar3" class="mr-2"></b-icon>カレンダー
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/ApplicationRegist"
                  :class="getClassBtnSideMenu('/manager/ApplicationRegist')"
                >
                  <b-icon icon="file-earmark-arrow-up" class="mr-2"></b-icon>事前申請
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/Approval"
                  :class="getClassBtnSideMenu('/manager/Approval')"
                  :disabled="(systemAuthorityType == null || systemAuthorityType == 0)"
                >
                  <b-icon icon="person-check-fill" class="mr-2"></b-icon>承認
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/ApplicationHistory"
                  :class="getClassBtnSideMenu('/manager/ApplicationHistory')"
                >
                  <b-icon icon="person-check" class="mr-2"></b-icon>承認状況
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/ApprovalHistory"
                  :class="getClassBtnSideMenu('/manager/ApprovalHistory')"
                  :disabled="(systemAuthorityType == null || systemAuthorityType == 0)"
                >
                  <b-icon icon="person-check-fill" class="mr-2"></b-icon>承認履歴
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/SubstituteHolidayManage"
                  :class="getClassBtnSideMenu('/manager/SubstituteHolidayManage')"
                >
                  <b-icon icon="calendar-check" class="mr-2"></b-icon>振替残管理
                </b-button>
                <!-- <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/MailResend"
                  :class="getClassBtnSideMenu('/manager/MailResend')"
                  disabled
                >
                  <b-icon icon="envelope" class="mr-2"></b-icon>メール再通知
                </b-button> -->
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/WorkSummary"
                  :class="getClassBtnSideMenu('/manager/WorkSummary')"
                  :disabled="(systemAuthorityType == null || systemAuthorityType == 0)"
                >
                  <b-icon icon="table" class="mr-2"></b-icon>集計表
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/AttendanceCheck"
                  :class="getClassBtnSideMenu('/manager/AttendanceCheck')"
                >
                  <b-icon icon="person-lines-fill" class="mr-2"></b-icon>在席確認
                </b-button>
                <!-- <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/ProxyApplication"
                  :class="getClassBtnSideMenu('/manager/ProxyApplication')"
                  disabled
                >
                  <b-icon icon="people" class="mr-2"></b-icon>代理申請設定/解除
                </b-button> -->
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  to="/manager/WorkState"
                  :class="getClassBtnSideMenu('/manager/WorkState')"
                >
                  <b-icon icon="table" class="mr-2"></b-icon>勤務状況
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  @click="clickPasswordChange()"
                >
                  <b-icon icon="lock" class="mr-2"></b-icon>ﾊﾟｽﾜｰﾄﾞ変更
                </b-button>
                <b-button
                  class="btnSideMenu"
                  variant="outline-light"
                  @click="clickLogout"
                >
                  <b-icon icon="power" class="mr-2"></b-icon>ログアウト
                </b-button>
              </div>
            </div>
          </nav>
          <div>
            <main class="manager_main">
              <router-view />
            </main>
          </div>
          <ChangeLoginPasswordModalVue ref="changeLoginPasswordModal"></ChangeLoginPasswordModalVue>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import config from "../../const/config";
  import ChangeLoginPasswordModalVue from "../../components/SystemUser/ChangeLoginPasswordModal.vue";
  
  export default {
    name: "SideBar",
    components: {ChangeLoginPasswordModalVue},
    props: {
      systemVersion: {type: String, default: ""}
    },
    data: function () {
      return {
        loginUserId: null,
        loginUserName: null,
        companyName: null,
        systemAuthorityType: 0,
      };
    },
    mounted: function () {
      this.loginUserId = this.$store.state.user_id;
      this.loginUserName = this.$store.state.user_name;
      this.systemAuthorityType = this.$store.state.system_authority_type;
      console.debug("systemAuthorityType：" + this.systemAuthorityType);
      this.getLoginInfo();
    },
    methods: {
      getClassBtnSideMenu: function (btnPath) {
        let setClass = "";
  
        if (this.$route.path == btnPath) {
          setClass = " btn_selected";
        }
        return setClass;
      },
      clickLogout: function(){
        // 状態をログアウトとする
      let message = "ログアウトします。<br>よろしいですか？";
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
          this.logout();
        });
      },
      logout: function () {
        this.postData(config.URL.LOGOUT)
          .then((respons) => {
            console.debug(respons);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.$router.push(config.PAGES.MANAGER_LOGIN);
          });
      },
      clickPasswordChange: function () {
        this.$refs.changeLoginPasswordModal.openModal();
      },
      // 会社名を取得するAPI
      getLoginInfo(){
        let paramList = {
          shainCd: this.loginUserId,
        }
        this.getWithParams(config.URL.HOME_INFO_MANAGER, paramList)
          .then((response) => {
            console.debug("response：" + JSON.stringify(response));
            // レスポンスの結果がfalseならエラーメッセージを表示
            if(!response.result){
              this.showAlertError(config.MESSAGE.SERVER_ERROR);
              return;
            }
            this.setLoginInfo(response.container);
          })
          .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
          })
          .finally(() => {});
      },
      setLoginInfo(item){
        this.companyName = item.companyName;
      }
    },
    
  };
  </script>
  
  <style>
  .system_title .btn {
    background: rgb(44, 76, 255);
    border: rgb(44, 76, 255);
  }
  
  .header_content {
    background: rgb(44, 76, 255) !important;
    box-shadow: 4px 3px 6px 3px rgb(201, 201, 201) !important;
  }
  
  .area_title {
    margin: 5px 0px;
    padding: 50px 45px;
    text-align: left;
    border-radius: 0px;
    color: rgb(94, 90, 90);
  }
  
  .btnSideMenu {
    border-top: none !important;
    border-bottom: none !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
    width: 100%;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    padding-left: 30px !important;
    color: rgb(94, 90, 90) !important;
    text-align: left !important;
    height: calc((100vh - 60px) / 15);
    display: flex !important;
    align-items: center !important;
  }
  
  .btn_selected {
    color: rgb(44, 76, 255) !important;
  }
  
  .sidebar {
    position: fixed;
    width: 250px;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    padding: 50px 0 0;
    /* box-shadow: inset -1px 0 0 rgb(0 0 0 / 10%); */
    box-shadow: 2px 2px 4px 3px rgb(209, 209, 209);
    background-color: rgb(255, 255, 255);
    background: rgb(255, 255, 255) !important;
  }
  
  main.manager_main {
    overflow-x: hidden;
    max-height: calc(100vh - 90px);
    margin-top: 20px;
    margin-left: 260px;
  }
  .manager_main main {
    max-height: 100%;
    overflow-y: hidden;
  }
  div.WorkM_MainArea {
    margin-bottom: 0px;
  }

  .right-col {
    display: flex;
    justify-content: end;
  }

  .TitleItem_TitleLabel {
    font-weight: bold;
  }
  </style>